import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { Card, Container } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { history } from '../..'
import agent from '../../app/api/agent'
import FooterNew from '../components/Footer'

function VerifyEmail() {
  const { t } = useTranslation()

  const Status = {
    Verifying: t('verifying'),
    Failed: t('failed'),
    Success: t('success'),
  }

  const useQuery = new URLSearchParams(useLocation().search)

  const userId = useQuery.get('id') as string
  const token = useQuery.get('token') as string

  const [status, setStatus] = useState(Status.Verifying)
  const [error, setError] = useState()

  function handleConfirmEmailResend() {
    agent.Account.resendEmailConfirm(encodeURIComponent(userId)) // check
      .then(() => {
        toast.success(t('verification_resend_success'))
      })
      .catch((error) => console.log(error))
  }

  useEffect(() => {
    agent.Account.verifyEmail(token, userId) // check
      .then(() => {
        setStatus(Status.Success)
      })
      .catch((err) => {
        setError(err.response.data)
        setStatus(Status.Failed)
      })
  }, [Status.Failed, Status.Success, token, userId])

  const handleLogin = async (): Promise<void> => {
    history.push('/login')
  }

  const STATUS_MESSAGE = [
    {
      status: status === Status.Failed,
      iClass: 'fa-regular text-danger fa-circle-xmark pe-3',
      h4Class: 'failed registration-text small-center',
    },
    {
      status: status === Status.Success,
      iClass: 'fa-regular text-success fa-circle-check pe-3',
      h4Class: 'successful-registration-text',
    },
    {
      status: status === Status.Verifying,
      iClass: 'fa-regular text-warning fa-circle-xmark pe-3',
      h4Class: 'registration-text waiting',
    },
  ]

  function getBody() {
    switch (status) {
      case Status.Verifying:
        return <p>{t('verifying')}...</p>
      case Status.Failed:
        return (
          <div className='small-center'>
            {error === 'email_has_been_verified' ? (
              <div>
                <p className='resend-description-card '>{t('email_has_been_verified')}</p>
                <button onClick={handleLogin} className='resend-verification-button mt-4'>
                  {t('login')}
                </button>
              </div>
            ) : (
              <div>
                <p className='resend-description-card '>{t('verification_email_failed')}</p>
                <div>
                  <button
                    className='resend-verification-button mt-4'
                    onClick={handleConfirmEmailResend}
                  >
                    {t('resend_email_verification')}
                  </button>
                </div>
              </div>
            )}
          </div>
        )
      case Status.Success:
        return (
          <div>
            <p>{t('verification_success')}</p>
            <button onClick={handleLogin} className='resend-verification-button'>
              {t('log_in')}
            </button>
          </div>
        )
    }
  }

  return (
    <>
      <Container
        fluid
        className='card-center card-background'
        style={{ marginTop: '80px', marginBottom: '50px' }}
      >
        <Card
          style={{ width: '800px' }}
          className='newFont prevent-select card-shadow login-card-size'
        >
          <Card.Header>
            <p className='login-card-title'>{t('reg_status')}</p>
          </Card.Header>
          <Card.Body className='card-padding padding-test card-font-size'>
            <Card.Title className=' d-flex align-center'>
              {STATUS_MESSAGE.map((c) => (
                <>
                  {c.status && (
                    <>
                      <i style={{ fontSize: '60px' }} className={c.iClass} />
                      <h4 className={c.h4Class}>{t('email_verification')}</h4>
                    </>
                  )}
                </>
              ))}
            </Card.Title>
            <div>{getBody()}</div>
          </Card.Body>
        </Card>
      </Container>
      <FooterNew />
    </>
  )
}
export default observer(VerifyEmail)
